// Commonly used in Jest test to disable portal in MUI because it breaks component testing and nodes are getting lost.
export const isTestEnvironment = process.env.NODE_ENV === 'test';